export const CHOICES_KEY = "bb_choices";
